import { ProjectsContext } from "App";
import api from "lib/api";
import Dropdown from "lib/Dropdown";
import { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

function Empty() {
  const history = useHistory();
  const startNew = () => {
    history.push("/create");
  };
  return (
    <div className="he">
      <div className="he-t">
        <div>
          <img src="/tabs.png" alt="Projects" width="300" />
        </div>
        <h1>Start by creating a new project</h1>
      </div>
      <div className="he-b">
        <button onClick={startNew}>New project</button>
      </div>
    </div>
  );
}

function Card({ project, remove }) {
  const actions = [{ name: "Rename" }, { name: "Delete" }];
  const ref = useRef();
  const history = useHistory();
  const [editing, setEditing] = useState(false);
  const open = () => {
    if (project.id) {
      history.push(`/editor/${project.id}`);
    } else {
      history.push("/editor");
    }
  };
  const action = (i) => {
    if (i.name === "Delete") {
      // api('/api/projects/delete', project).then(() => remove())
    }
    if (i.name === "Rename") {
      setEditing(true);
    }
  };
  function onKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      const name = e.target.innerHTML;
      api("/api/projects/rename", {
        id: project.id,
        name,
      }).then(() => {
        setEditing(false);
      });
    }
  }
  useEffect(() => {
    if (editing) ref.current.focus();
  }, [editing]);
  useEffect(() => {
    ref.current.innerHTML = project.name;
  }, [project.name]);
  return (
    <div className="ds-c">
      <div className="ds-i" onClick={open}>
        <img src="/design.png" alt="preview" />
      </div>
      <div className="ds-t">
        <div
          className="ds-tl"
          ref={ref}
          contentEditable={editing}
          onKeyDown={onKeyDown}
        />
        <div>
          <Dropdown select={action} items={actions} />
        </div>
      </div>
    </div>
  );
}

function Projects() {
  const history = useHistory();
  const { projects } = useContext(ProjectsContext);
  if (projects.length === 0) return <Empty />;
  const addNew = () => history.push("/create");
  return (
    <div className="ds">
      <div className="ds-t">
        <div className="ds-l">Projects</div>
        <div>
          <button onClick={addNew}>New</button>
        </div>
      </div>
      {projects.map((p, i) => {
        return <Card project={p} key={i} />;
      })}
    </div>
  );
}

export default function Home() {
  return (
    <div className="hm">
      <Projects />
    </div>
  );
}
